import { memo } from 'react';

import { BoardAdd } from '@air/next-icons';
import { IconButton, type IconButtonProps } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

export type AddToBoardButtonProps = Pick<Required<IconButtonProps>, 'onClick'>;

export const AddToBoardButton = memo(({ onClick }: AddToBoardButtonProps) => (
  <Tooltip label="Add to Board">
    <IconButton
      label="Add to Board"
      appearance="ghost"
      color="grey"
      className="ui2:rounded-4 text-grey-1 hover:text-grey-10 active:text-grey-9"
      onClick={onClick}
      size="small"
    >
      <BoardAdd className="size-4" />
    </IconButton>
  </Tooltip>
));

AddToBoardButton.displayName = 'AddToBoardButton';
